/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { internalSessionIssuersGet } from "../funcs/internalSessionIssuersGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { InternalSessionIssuer } from "../models/components/internalsessionissuer.js";
import {
  GetInternalSessionIssuerRequest,
  GetInternalSessionIssuerSecurity,
} from "../models/operations/getinternalsessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
export type InternalSessionIssuerQueryData = InternalSessionIssuer;

export function prefetchInternalSessionIssuer(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetInternalSessionIssuerRequest | undefined,
  security?: GetInternalSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildInternalSessionIssuerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildInternalSessionIssuerQuery(
  client$: GramCore,
  request?: GetInternalSessionIssuerRequest | undefined,
  security?: GetInternalSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<InternalSessionIssuerQueryData>;
} {
  return {
    queryKey: queryKeyInternalSessionIssuer({
      gramSession: request?.gramSession,
    }),
    queryFn: async function internalSessionIssuerQueryFn(
      ctx,
    ): Promise<InternalSessionIssuerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(internalSessionIssuersGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyInternalSessionIssuer(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "internalSessionIssuers", "get", parameters];
}
